export const STATUSES = {
  N: {
    name: 'Eligible not enrolled',
    color: 'orange',
  },
  P: {
    name: 'Pending enrollment',
    color: 'yellow',
    subStatuses: {
      P: {
        name: 'Contact initiated',
        shortName: 'Contact initiated',
        canBeChangedToThisStatus: true,
      },
      P2: {
        name: '2nd Attempt Required',
        canBeChangedToThisStatus: true,
      },
      P3: {
        name: '3rd Attempt Required',
        shortName: '3rd Attempt Required',
        canBeChangedToThisStatus: true,
      },
      PN: {
        name: 'Needs Office Visit',
        shortName: 'Needs Office Visit',
      },
      PS: {
        name: 'Pending Suspended',
      },
    },
  },
  C: {
    name: 'Currently Enrolled',
    color: 'green',
    subStatuses: {
      CC: {
        name: 'Care plan completed',
      },
      CN: {
        name: 'Enrolled',
      },
      CS: {
        name: 'Suspended',
      },
    },
  },
  I: {
    name: 'Ineligible',
    color: 'oslo',
    permissions: ['patients:view:ineligible'],
  },
  D: {
    name: 'Declined',
    color: 'red',
    subStatuses: {
      DP: {
        name: 'Declined by patient',
        shortName: 'By Patient',
      },
      DC: {
        name: 'Declined by Care Provider',
        shortName: 'By Care Provider',
      },
    },
  },
  X: {
    name: 'Dis-enrolled',
    color: 'bismark',
  },
  E: {
    name: 'Unable to Reach',
    color: 'navy',
  },
};

export const ALL_BULK_STATUSES = ['N', 'P', 'P2', 'P3', 'PN', 'PS', 'CS', 'I', 'DP', 'DC', 'X', 'E'];

export const SUSPEND_STATUSES = {
  suspendReasons: {
    OTHER: 'Other',
    PENDING_MANAGEMENT_REVIEW: 'Pending management review',
    CALL_IN_FUTURE: 'Patient would like call in future',
    BAD_NUMBER: 'Unable to reach: bad number',
    NOT_SEEN_BY_PCP: 'Patient has not been seen by PCP in > 1 year',
    HAS_NOT_YET_PCP: 'Has not yet established new PCP',
    INSURANCE_CHANGE: 'Insurance eligibility change',
    LANGUAGE_GAP: 'Language gap',
    NO_ANSWER: 'Unable to reach: no answer',
    NO_SHOW: 'Patient was a no-show for their telehealth visit',
  },
};

export const ENROLLED_STATUSES = ['CC', 'CS', 'CN'];

export const LEGEND_STATUSES = {
  ANY: {
    id: '*',
    color: 'gray',
    name: 'All Patients (any status)',
  },
  CN: {
    id: 'CN',
    color: 'green',
    name: 'Enrolled',
    permissions: ['patients:view:enrolled'],
  },
  CC: {
    id: 'CC',
    color: 'green',
    name: 'Care plan completed',
    permissions: ['patients:view:careplancomplete'],
  },
  CS: {
    id: 'CS',
    color: 'green',
    name: 'Suspended',
    permissions: ['patients:view:suspended'],
  },
  X: {
    id: 'X',
    color: 'bismark',
    name: 'Dis-enrolled',
    permissions: ['patients:view:disenrolled'],
  },
  I: {
    id: 'I',
    color: 'oslo',
    name: 'Ineligible',
    permissions: ['patients:view:ineligible'],
  },
  N: {
    id: 'N',
    color: 'orange',
    name: 'Eligible not enrolled',
    permissions: ['patients:view:notenrolled'],
  },
  P: {
    id: 'P',
    color: 'yellow',
    name: 'Contact initiated',
    permissions: ['patients:view:initiated'],
  },
  P2: {
    id: 'P2',
    color: 'yellow',
    name: '2nd Attempt Required',
    permissions: ['patients:view:attempt2'],
  },
  P3: {
    id: 'P3',
    color: 'yellow',
    name: '3rd Attempt Required',
    permissions: ['patients:view:attempt3'],
  },
  PN: {
    id: 'PN',
    color: 'yellow',
    name: 'Needs Office Visit',
    permissions: ['patients:view:needsofficevisit'],
  },
  PS: {
    id: 'PS',
    color: 'yellow',
    name: 'Pending Suspended',
    permissions: ['patients:view:pendingsuspend'],
  },
  E: {
    id: 'E',
    color: 'navy',
    name: 'Unable to Reach',
    permissions: ['patients:view:unablereach'],
  },
  DP: {
    id: 'DP',
    color: 'red',
    name: 'Declined by patient',
    permissions: ['patients:view:declinedpatient'],
  },
  DC: {
    id: 'DC',
    color: 'red',
    name: 'Declined by Care Provider',
    permissions: ['patients:view:declinedprovider'],
  },
};
